import o from "./ghl-ui.es782.js";
import t from "./ghl-ui.es658.js";
var a = o(t, "Map");
const e = a;
export {
  e as default
};
